import { render, staticRenderFns } from "./OccupancyFeeReceiptsPayments.vue?vue&type=template&id=267bd8db&scoped=true"
import script from "./OccupancyFeeReceiptsPayments.vue?vue&type=script&lang=js"
export * from "./OccupancyFeeReceiptsPayments.vue?vue&type=script&lang=js"
import style0 from "./OccupancyFeeReceiptsPayments.vue?vue&type=style&index=0&id=267bd8db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267bd8db",
  null
  
)

export default component.exports